import { CompaniesKeys } from '../companies.key';
import { Places } from '../../../../route-consts';
/**
 * O dialogo de cadastro e de edicao de empresa.
 *
 * Um place so para os dois casos: `target` ausente e cadastrar, presente e editar.
 * Sao o mesmo formulario e a mesma validacao, e dois places dariam duas classes
 * identicas cuja unica diferenca seria o nome.
 *
 * Herda de `CompaniesKeys`, entao os filtros da lista viajam para o dialogo e
 * voltam com ele - fechar cai na mesma lista filtrada.
 */
export class CompanyEditKeys extends CompaniesKeys {
    get place() {
        return Places.companyEdit;
    }
}
//# sourceMappingURL=company-edit.key.js.map